import MuiPagination, { type PaginationProps } from "@mui/material/Pagination";

export type { PaginationProps };

export function Pagination(props: PaginationProps) {
  return <MuiPagination {...props} />;
}
